import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { IButtonDirective, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-dashboard360-usaved-changes-modal",
  imports: [IButtonDirective, TranslocoDirective],
  templateUrl: "./dashboard360-usaved-changes-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Dashboard360UsavedChangesModalComponent {
  readonly modalRef = inject(ModalRef);
}
